/* eslint-disable import/prefer-default-export */
export const fieldBodyGenerator = (label, styles = {}, subtexts = []) => ({
  label,
  styles,
  subtexts
});

export const sumFieldAcres = fields =>
  fields.reduce((prev, curr) => prev + curr.areaValue, 0);
